module.exports = __webpack_public_path__ + "img/13.45ec8af2.png";